(function(){
  if(window.__ktCyber)return; window.__ktCyber=1;
  var END=new Date('2026-10-07T23:59:59-03:00').getTime();
  function p(n){return (n<10?'0':'')+n;}
  function build(){
    if(document.getElementById('ktCyberBar'))return;
    var css=document.createElement('style');
    css.textContent='#ktCyberBar{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:.5rem .9rem;background:linear-gradient(90deg,#B71F18,#DD2E24 55%,#F2A65A);color:#fff;padding:.7rem 1.1rem;text-align:center;font-family:Manrope,system-ui,-apple-system,sans-serif}#ktCyberBar *{color:#fff}#ktCyberBar .t{font-weight:900;letter-spacing:.09em;font-size:.9rem;background:rgba(0,0,0,.28);padding:.26rem .72rem;border-radius:999px;white-space:nowrap}#ktCyberBar .x{font-weight:700;font-size:.9rem}#ktCyberBar .c{font-weight:900;font-size:1rem;font-variant-numeric:tabular-nums;background:rgba(0,0,0,.3);padding:.28rem .78rem;border-radius:8px;white-space:nowrap}#ktCyberBar.fin{background:#3A2229}@media(max-width:600px){#ktCyberBar{padding:.5rem .8rem;gap:.3rem .6rem}#ktCyberBar .t,#ktCyberBar .x{font-size:.78rem}#ktCyberBar .c{font-size:.9rem}}';
    document.head.appendChild(css);
    var bar=document.createElement('div');
    bar.id='ktCyberBar';
    bar.innerHTML='<span class="t">CYBER KT</span><span class="x">Precios de liquidación activos &middot; terminan el miércoles 7 a las 23:59</span><span class="c" id="ktCd">--:--:--</span>';
    document.body.insertBefore(bar, document.body.firstChild);
    tick();
  }
  function tick(){
    var el=document.getElementById('ktCd'); if(!el)return;
    var d=END-Date.now();
    if(d<=0){el.textContent='Finalizado';var b=document.getElementById('ktCyberBar');if(b)b.className='fin';return;}
    var dd=Math.floor(d/86400000),h=Math.floor(d/3600000)%24,m=Math.floor(d/60000)%60,s=Math.floor(d/1000)%60;
    el.textContent=(dd>0?dd+'d ':'')+p(h)+':'+p(m)+':'+p(s);
    setTimeout(tick,1000);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',build);}else{build();}
})();